"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var styled_components_1 = __importStar(require("styled-components"));
var components_1 = require("components");
var libzl_1 = require("../libzl");
var WorkInfo = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    z-index: 10;\n    position: absolute;\n    width: 100%;\n    height: 90%;\n    background-color: transparent;\n    pointer-events: none;\n\n    @media ", " {\n        z-index: 1510;\n        position: fixed;\n        top: 0;\n        bottom: 0;\n        left: 0;\n        right: 0;\n        height: 100%;\n    }\n"], ["\n    z-index: 10;\n    position: absolute;\n    width: 100%;\n    height: 90%;\n    background-color: transparent;\n    pointer-events: none;\n\n    @media ", " {\n        z-index: 1510;\n        position: fixed;\n        top: 0;\n        bottom: 0;\n        left: 0;\n        right: 0;\n        height: 100%;\n    }\n"])), function (props) { return props.theme.breakpoints.fullScreenStream; });
var WorkIndicator = /** @class */ (function (_super) {
    __extends(WorkIndicator, _super);
    function WorkIndicator(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            showMe: false,
            d2dActivity: {
                segments: {},
                progress: 0,
                total: 0
            },
            zlready: false
        };
        return _this;
    }
    WorkIndicator.prototype.componentDidUpdate = function (prevProps) {
        if (prevProps.zlbolt === undefined && this.props.zlbolt) {
            libzl_1.initWorkIndicator(this, this.props.zlbolt);
        }
    };
    WorkIndicator.prototype.render = function () {
        var total = this.state.d2dActivity.total;
        var progress = this.state.d2dActivity.progress;
        var ready = this.state.zlready;
        return (react_1.default.createElement(WorkInfo, null, (this.props.zlbolt === undefined || !ready || (total > 0 && progress < total)) &&
            react_1.default.createElement(components_1.WorkIndicator, null)));
    };
    return WorkIndicator;
}(react_1.Component));
exports.default = styled_components_1.withTheme(WorkIndicator);
var templateObject_1;
//# sourceMappingURL=WorkIndicator.js.map